<template>
    <div>
       
    </div>
</template>

<script>
export default {
    
}
</script>

<style  scoped>
li{
    display: inline;
    list-style-type: none;
    padding-right: 20px;
    float: left;
}
</style>